export const intervalResearchesModel = {
    name: 'intervalResearches',
    state: {
        data: {},
        isLoading: false,
    },
    reducers: {
        setIntervalResearches(state, payload) {
            return { ...state, data: payload };
        },
    },
};
